import { showDiscoverMenuWithManifest } from '@fluidx/host-ux';
import type { ContainerManifestEntry } from '@fluidx/office-fluid-types';
import { EditorViewState, lazyOperateContent } from 'owa-editor';
import { logDiscoverMenuOpened, logDiscoverMenuPreloadFailed } from 'owa-fluid-datapoints';
import { ComposeLinkParameters, lazyModule as fluidLinkModule } from 'owa-fluid-link';
import type { FluidOwaSource } from 'owa-fluid-validations';
import { getGuid } from 'owa-guid';
import { preloadDiscoverManifest } from './preloadDiscoverManifest';
import { createNewFluidComponent } from '../components/FluidPlaceholder';
import { getIsDiscoverManifestLoaded } from '../selectors/getIsDiscoverManifestLoaded';
import type { FluidContainerConfigForEditor } from '../store/schema/FluidContainerConfig';

export async function renderFluidHeroMenu(
    targetWindow: Window,
    viewState: EditorViewState,
    composeLinkParameters: ComposeLinkParameters,
    subject: string,
    coordinates: { x: number; y: number },
    owaSource: FluidOwaSource,
    addRecipientFunc: (address: string) => void,
    viewStateId: string
) {
    if (!getIsDiscoverManifestLoaded()) {
        logDiscoverMenuPreloadFailed();
        await preloadDiscoverManifest();
    }

    const requestData = {
        hostContext: {
            floatingUXContext: {
                ownerDocument: targetWindow.document,
                coordinates,
            },
            flip: true /** sets the orientation of the menu, opens upwards when true */,
        },
        insertionContext: {
            onInsertActivityBlueprint: (manifestEntry: ContainerManifestEntry) => {
                const componentType = manifestEntry.queryableData.displayName;
                const containerConfig: FluidContainerConfigForEditor = {
                    configType: 'editor',
                    editorViewState: viewState,
                    containerId: 'fluidContainer' + getGuid(),
                };
                createNewFluidComponent(
                    containerConfig,
                    manifestEntry.codeDetails,
                    manifestEntry.heroConfiguration,
                    componentType,
                    composeLinkParameters,
                    subject,
                    targetWindow,
                    owaSource,
                    addRecipientFunc,
                    viewStateId
                );
            },
        },
    };
    showDiscoverMenuWithManifest(requestData);
    // We preload the code to create new fluid links when the menu is opened.
    fluidLinkModule.import();
    lazyOperateContent.import();
    logDiscoverMenuOpened();
}
